import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';
import useMultiImageBox from 'hooks/useMultiImageBox';
import useToggle from 'hooks/useToggle';
import { memo } from 'react';
import { ImageFallbackProductImage } from 'utils/ImageFallback';
import { isEmpty } from 'utils/ValidateUtils';
import PopupMultilImage from '../PopupMultilImage';
import styles from './styles.module.css';

function ListPromoGift({ srcImagesProxy, width, height, imageName, isMobile = false, name = '', lengthList }) {
  const { open, handleClose, handleOpen } = useToggle();
  const { selectedImage, handleImageSelection, handlePrevious, handleNext } = useMultiImageBox({ images: srcImagesProxy });
  const handleOpenPopup = () => {
    handleOpen();
  };

  return (
    <Grid
      className={clsx(styles.wrapPromoImg, isMobile && styles.wrapPromoImgMobile, lengthList > 3 && styles.wrapPromoResize)}
      // onClick={() => handleGetDataProduct(slugProduct)}
    >
      {/* <LinkComp href={link}> */}
      <Tooltip title={name} arrow>
        <Grid onClick={handleOpenPopup} role="presentation" style={{ cursor: 'pointer' }}>
          <ImageFallbackProductImage
            src={!isEmpty(srcImagesProxy) && `${srcImagesProxy[0]}`}
            width={width}
            height={height}
            objectFit="contain"
          />
        </Grid>
      </Tooltip>
      {open && (
        <PopupMultilImage
          isMobile={isMobile}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          handleClickImage={handleImageSelection}
          selectedImage={selectedImage}
          open={open}
          handleClose={handleClose}
          images={srcImagesProxy}
          imageName={imageName}
        />
      )}
    </Grid>
  );
}

export default memo(ListPromoGift);
